// Dependencies
import { ChangeEventHandler, FC, FocusEventHandler, ReactElement } from "react";

// Styles
import { StyledInput } from "./TextInput.styled";

interface TextInputProps {
  type?: string;
  name: string;
  onChange: ChangeEventHandler;
  onBlur: FocusEventHandler;
  value: string | number;
  placeholder?: string;
  defaultValue?: string;
  icon?: ReactElement;
  endAdornment?: ReactElement;
  autoComplete?: string;
  select?: boolean;
}

const TextInput: FC<TextInputProps> = ({ endAdornment, ...props }) => {
  return (
    <StyledInput
      {...props}
      fullWidth={true}
      InputProps={{
        endAdornment: endAdornment,
      }}
    ></StyledInput>
  );
};

export default TextInput;
